import { Icon, Text } from "@nulogy/components";
import React from "react";
import renderToString from "./renderToString";

export default function filterHeaderRenderer() {
  return renderToString(
    <div>
      <Text fontSize="small" fontWeight="medium" inline style={{ verticalAlign: "middle" }}>
        Filter line(s)
      </Text>
      <Icon color="darkBlue" icon="help" ml="half" size="16px" style={{ verticalAlign: "middle" }} />
    </div>,
  );
}
